import React, { useContext } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from '../../context/AppContext';
const ChatNavigate = () => {

  const {

    customerData,
    subModule,
  } = useContext(AppContext);







    const openChat = () => {
        // Add your chat service logic here
        console.log("Chat Icon Clicked");
        const url = `https://www.vehicletracking.live/?subModule=${subModule}&userId=${customerData.id}&userName=${encodeURIComponent(customerData.customer_first_name)}`;
        window.open(url, "_blank");
      };
    
    return (

                      <div 
       style={{
        position: "fixed",
        bottom: "90px",
        right: "20px",
        backgroundColor: "#9c4900",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: "1000", // Ensure it appears above other elements
        cursor: "pointer",
      }}
      onClick={openChat}
    >
      <FontAwesomeIcon icon={faComments} color="white" size="lg" />

        </div>
    );
};

export default ChatNavigate;